const riot = require('riot');

// global mixin
riot.mixin({
  bubbleTrigger(type, argument, info) {
    if (info === true) {
      info = {
        bubbles: true,
      };
    }

    if (!info) {
      info = {
        bubbles: true,
      };
    }

    // 初めて発火した
    if (!info.src) {
      info.src = this;
      info.path = [this];
      info.bubbles = !!info.bubbles;
      info.stop = false;
    }
    // bubbling によって発火した
    else {
      info.path.push(this);
    }

    this.trigger(type, argument, info);

    if (info.bubbles && !info.stop) {
      this.parent && this.parent.bubbleTrigger(type, argument, info);
    }
  },
});
